import React, { useState } from "react";
import Contact from "./Contact";

const UniquickSolutions = () => {
  const [navbar, setNavbar] = useState(false);

  if (window !== undefined) {
    window?.addEventListener("resize", () => {
      // console.log(window?.innerWidth);
      if (window?.innerWidth > 768) {
        setNavbar(false);
      }
    });
  }

  return (
    <>
      <header id="header" className="fixed-top">
        <div className="container d-flex align-items-center justify-content-between">
          <h1 className="logo">
            <a href="index.html">
              <img src="/img/logo/logo1.png" alt="ProvenMinds" />
            </a>
            Uniquick Solutions
          </h1>
          <nav
            id="navbar"
            className={navbar ? "navbar navbar-mobile" : "navbar"}
          >
            <ul>
              <li onClick={() => setNavbar(false)}>
                <a className="nav-link scrollto active" href="#hero">
                  Home
                </a>
              </li>
              <li onClick={() => setNavbar(false)}>
                <a className="nav-link scrollto" href="#about">
                  About
                </a>
              </li>
              <li onClick={() => setNavbar(false)}>
                <a className="nav-link scrollto" href="#services">
                  Services
                </a>
              </li>
              <li onClick={() => setNavbar(false)}>
                <a className="nav-link scrollto" href="#contact">
                  Contact
                </a>
              </li>
            </ul>
            <i
              onClick={() => setNavbar(!navbar)}
              className={
                navbar
                  ? "bi bi-x mobile-nav-toggle"
                  : "bi bi-list mobile-nav-toggle"
              }
            ></i>
          </nav>
        </div>
      </header>
      <section id="hero" className="d-flex align-items-center ">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex flex-column justify-content-center">
              <h1 className="text-uppercase">
                Our Minds For <br /> Your Solutions
              </h1>

              <div className="d-flex mt-3">
                <h2>
                  We build digital products that serve users worldwide.Tap into
                  our multi-yeardomain expertise to drive your digital
                  transformation strategy.
                </h2>
              </div>
            </div>
            <div className="col-lg-6 order-1 order-lg-2 hero-img">
              <img
                src="assets/img/hero-img.png"
                className="img-fluid animated"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <main id="main">
        <section id="featured-services" className="featured-services">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bi bi-cloud"></i>
                  </div>
                  <h4 className="title">
                    <a href="">Custom Software Development</a>
                  </h4>
                  <p className="description">
                    Whether you are a start-up or an established business, we
                    are ready to assist you at every stage of the software
                    development life cycle — from conceptualization and
                    consulting to development and support.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mt-4 mt-md-0">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bi bi-laptop"></i>
                  </div>
                  <h4 className="title">
                    <a href="">Web Application Development</a>
                  </h4>
                  <p className="description">
                    Our software engineers have a wealth of experience in
                    building web applications. We are also experts in many
                    verticals and business domains, including e-Commerce,
                    e-Learning, AdTech, Finance, Entertainment, and more
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mt-4 mt-lg-0">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bi bi-phone-vibrate"></i>
                  </div>
                  <h4 className="title">
                    <a href="">Mobile Application Development</a>
                  </h4>
                  <p className="description">
                    Develop powerful, highly usable mobile apps that solve
                    business problems, attract users, and reinforce your brand.
                    We build native, hybrid, and cross-platform apps that run on
                    all major operating systems such as iOS and Android.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="about" className="about">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <img src="assets/img/about.png" className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 pt-4 pt-lg-0 content">
                <h3>HOW WE WORK</h3>
                <p className="fst-italic">
                  Whatever the approach your project demands, we have the skills
                  and the expertise to work independently, or seamlessly
                  integrate with your team to help deliver outstanding results.
                </p>
                <ul>
                  <li>
                    <i className="bi bi-check-circle"></i> Use Our Low-Risk
                    Development Approach to Leave Competition in the Dust
                  </li>
                  <li>
                    <i className="bi bi-check-circle"></i> Complex software
                    projects impose high demands on outsourcing vendors.
                  </li>
                  <li>
                    <i className="bi bi-check-circle"></i> To be a success, a
                    project needs to deliver a custom product that provides
                    tangible business value, advances your market position, and
                    propels you ahead of the competition — all while meeting the
                    expected scope requirements,schedule, and budget
                    constraints.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section id="services" className="services section-bg">
          <div className="container">
            <div className="section-title">
              <span>Services</span>
              <h2>Services</h2>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bx bx-cloud-download"></i>
                  </div>
                  <h4>
                    <a className="text-capitalize" href="">
                      Custom Software Development
                    </a>
                  </h4>
                  <p>
                    We offer custom software development and consulting services
                    to help you pull off your next project with less stress and
                    less cost. Our team has the technology prowess to power you
                    at every stage of your product development lifecycle, from
                    discovery to ongoing post-launch enhancement
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bx bx-mobile"></i>
                  </div>
                  <h4>
                    <a href="">Mobile App Development</a>
                  </h4>
                  <p>
                    ProvenMinds is a one-stop mobile app development company
                    with over 70 successful projects under its belt. We create
                    mobile apps of any complexity and size: award-winning B2C
                    applications and heavy, enterprise-grade mobile solutions
                    that power mission-critical processes beyond mere
                    automation.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bx bx-world"></i>
                  </div>
                  <h4>
                    <a href=""> Web Development</a>
                  </h4>
                  <p>
                    ProvenMinds is a web development company with over a decade
                    of experience in building world-className B2B and B2C
                    applications
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bx bx-tachometer"></i>
                  </div>
                  <h4>
                    <a href="">Software Testing & QA</a>
                  </h4>
                  <p>
                    offers full-cycle testing and quality assurance services
                    htmlFor desktop and mobile applications. Expert test
                    engineers are an integral part of every project we work on
                    to ensure the deliverables meet the most stringent quality
                    standards.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bx bx-slideshow"></i>
                  </div>
                  <h4>
                    <a href="">Dedicated Development Center</a>
                  </h4>
                  <p>
                    The Dedicated Development Center collaboration model is a
                    great fit htmlFor businesses who need to quickly ramp up
                    their development resources or augment their internal
                    development teams with rare or highly specialized talent.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="team" className="team section-bg">
          <div className="container">
            <div className="section-title">
              <span>OUR DIFFERENTIATORS</span>
              <h2>OUR DIFFERENTIATORS</h2>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
                <div className="member">
                  <img src="./img/differtiator_img1.png" alt="" />
                  <h4>IPR PROTECTION</h4>
                  <p>
                    We take your intellectual property rights very seriously. To
                    make sure your ideas stay yours, we sign a strict NDA from
                    day one to secure your exclusive ownership of the codebase
                    and other deliverables.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
                <div className="member">
                  <img src="./img/differtiator_img2.png" alt="" />
                  <h4>BEST-IN-className R&D UNIT</h4>
                  <p>
                    Our team of results-driven R&D experts will support you at
                    any point during the product development cycle. Whether you
                    face a strategic pivot or hit a roadblock — we’ve got you
                    covered all the way.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
                <div className="member">
                  <img src="./img/differtiator_img3.png" alt="" />
                  <h4>ROCK-SOLID GUARANTEE</h4>
                  <p>
                    Every contract includes guarantee clauses to ensure that we
                    complete your project on time and on budget. You will also
                    get a 6-month warranty obliging us to fix major and critical
                    defects discovered upon project completion.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Contact />
      </main>

      <footer id="footer">
        <div className="container footer-bottom clearfix">
          <div className="copyright">
            &copy; Copyright{" "}
            <strong>
              <span>uniquicksolutions.com</span>
            </strong>
            . All Rights Reserved
          </div>
        </div>
      </footer>

      <a
        href="#"
        className="back-to-top d-flex align-items-center justify-content-center"
      >
        <i className="bi bi-arrow-up-short"></i>
      </a>
    </>
  );
};

export default UniquickSolutions;
